/**
 * Wraps sign-in and PIN unlock. An already-authenticated user landing here is sent on to where
 * they were going, or to the sale screen.
 *
 * Same rule as `ProtectedRoute`: decided during render, never from an effect.
 */

import { Navigate, Outlet, useLocation } from 'react-router';

import { selectStatus } from '@pos/shared';

import { useAppSelector } from '@/app/hooks';

type LocationState = { from?: string } | null;

export function PublicOnlyRoute() {
  const status = useAppSelector(selectStatus);
  const location = useLocation();

  if (status === 'active') {
    const from = (location.state as LocationState)?.from;
    return <Navigate to={from ?? '/sell'} replace />;
  }

  return (
    // Below md the screen is the screen: no card, no margin, no backdrop — a floating card at
    // 360px is a phone pretending to be a monitor. From md it is a centred 420px card on the
    // backdrop; sign-in has no second panel to fill, so it does not get the two-panel width.
    <main className="flex h-dvh flex-col items-center justify-center bg-surface-base md:bg-surface-backdrop md:px-5 md:py-8">
      <div className="flex h-full w-full flex-col md:h-auto md:max-w-[420px]">
        <Outlet />
      </div>
    </main>
  );
}
